export const contentTableConfig = {
  title: '活动列表',
  propList: [
    {prop: 'id', label: "活动编号", minWidth: '40'},
    {prop: 'raffleName', label: '活动名称', minWidth: '80', slotName: "raffleName"},
    {prop: 'grantAmount', label: '发放金额', minWidth: '80'},
    {prop: 'receivedAmount', label: '已领取金额', minWidth: '80'},
    {prop: 'participateNum', label: '参与人数', minWidth: '80'},
    {prop: 'surplusNum', label: '剩余红包', minWidth: '80'},
    {prop: 'startTime', label: '开始时间', minWidth: '80'},
    {prop: 'endTime', label: '结束时间', minWidth: '80'},
    {prop: 'raffleStatus', label: '活动状态', minWidth: '80', slotName: 'status'},
    {label: '操作', minWidth: '180', slotName: 'handler'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
